module.exports = __webpack_public_path__ + "img/xz2.bcc8573f.jpg";